import React from "react";
import InsightCard from "../InsightCard/InsightCard";
import "../../styles/insightCards.css";

/**
 * Card with title and a single button (e.g. "Historic Utilization", "Historic ABC/OFL/Landings").
 */
export default function InsightButtonCard({ title, buttonLabel, onClick }) {
  return (
    <InsightCard title={title}>
      <div className="insight-columns">
        <button
          type="button"
          className="insight-column clickable-column"
          style={{ marginRight: 0, cursor: "pointer", minHeight: "40px" }}
          onClick={onClick}
        >
          {buttonLabel}
        </button>
      </div>
    </InsightCard>
  );
}
